import React from "react";
import { ENQUIRE_LINK, PLANNER_STORAGE_KEY } from "./utils/constants";

export default ({ panel, showText, buttonClass }) => {
    const onEnquire = () => {
        let addedPanels =
            JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || [];
        const found = addedPanels.find((p) => p.id === panel.id);
        if (!found) {
            addedPanels.push(panel);
            localStorage.setItem(
                PLANNER_STORAGE_KEY,
                JSON.stringify(addedPanels)
            );
        }

        window.location.href = ENQUIRE_LINK;
    };

    const dataAdd = () => {
        dataLayer.push({ event: "Enquire Click", panelId: panel.siteID });
    };

    return (
        <span className="panel__mail" onClick={dataAdd}>
            <button onClick={onEnquire} className={buttonClass}>
                <span className="text">Enquire now</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="none" fill-rule="evenodd">
                        <circle cx="25.5" cy="25.5" r="25.5" fill="#FFF" />
                        <path
                            d="M40.36 15H11.64c-.9 0-1.64.73-1.64 1.62v17.76c0 .9.74 1.62 1.64 1.62h28.72c.9 0 1.64-.73 1.64-1.62V16.62c0-.9-.74-1.62-1.64-1.62Zm-.62 1.21-12.8 9.45c-.23.17-.58.28-.94.28s-.71-.1-.94-.28l-12.8-9.45h27.48ZM32.91 26.3l6.97 8.48.02.02H12.1l.02-.02 6.97-8.48a.6.6 0 0 0-.09-.86.62.62 0 0 0-.86.1l-6.9 8.4V16.96l13.08 9.66c.49.36 1.09.52 1.68.52.6 0 1.19-.16 1.68-.52l13.09-9.66v16.95l-6.9-8.4a.62.62 0 0 0-.87-.09.6.6 0 0 0-.1.86Z"
                            fill="#000"
                            fill-rule="nonzero"
                        />
                    </g>
                </svg>
            </button>
        </span>
    );
};
